module.exports = function(app) {
	'use strict';

	app.directive('eprTobaccoStatus', function() {
		return {
			template: require('directives/employee/eprTobaccoStatus.html'),
			restrict: 'A',
			replace: false,

			scope: {
				participant: '=eprTobaccoStatus',
				isRelevant: '=',
				groupNumber: '=?',
				index:'=?eprTobaccoIndex',
				editMode: '=?'
			},

			controller: ['$scope','$rootScope','employee','addFlowCommander', function($scope, $rootScope, employee, addFlowCommander) {
				$scope.tobaccoUsageDate;
				$scope.tobaccoStatus;


				var setTobaccoData = function(groupNumber , status) {
					for (var i = 0, memberCoverages = $scope.participant.memberCoverages || []; i < memberCoverages.length; ++i) {
						if (groupNumber && memberCoverages[i].groupNumber !== groupNumber) {
							continue;
						}
						for (var x = 0, memberLobs = memberCoverages[i].memberLobs || []; x < memberLobs.length; ++x) {
							if (memberLobs[x].coverageType && memberLobs[x].coverageType.toLowerCase() === 'medical') {
                               if(!$scope.isRelevant || status ==='FromBroadCast'){
                                   if(memberCoverages[i].tobaccoStatus == 'U'){
                                       memberCoverages[i].tobaccoStatus = 'N'
                                   }
                                   if ($scope.index !== undefined && employee.metadata.tobaccoData && employee.metadata.tobaccoData[$scope.groupNumber] && employee.metadata.tobaccoData[$scope.groupNumber][$scope.index]) {
                                       $scope.tobaccoStatus = employee.metadata.tobaccoData[$scope.groupNumber][$scope.index].tobaccoStatus;
                                       $scope.tobaccoUsageDate = employee.metadata.tobaccoData[$scope.groupNumber][$scope.index].tobaccoUsageDate;

                                   }
                                   else {
                                       $scope.tobaccoStatus = memberCoverages[i].tobaccoStatus || '';
                                       $scope.tobaccoUsageDate = memberCoverages[i].tobaccoUsageDate || '';
                                   }
                               }

							}
						}
                        employee.metadata.tobaccoData = employee.metadata.tobaccoData || {};
                        employee.metadata.tobaccoData[$scope.groupNumber] = employee.metadata.tobaccoData[$scope.groupNumber] || [];
                        $scope.$watch("tobaccoStatus", function(newValue) {
                            employee.metadata.tobaccoData[$scope.groupNumber][$scope.index] = employee.metadata.tobaccoData[$scope.groupNumber][$scope.index] || {};
                            employee.metadata.tobaccoData[$scope.groupNumber][$scope.index].tobaccoStatus = newValue;
                            employee.metadata.tobaccoData[$scope.groupNumber][$scope.index].pin = $scope.participant.pin || [];
                            employee.metadata.tobaccoData[$scope.groupNumber][$scope.index].fullname = $scope.participant.fullName || {};
                            employee.metadata.tobaccoData[$scope.groupNumber][$scope.index].gender = $scope.participant.gender || [];


                        });
                        $scope.$watch("tobaccoUsageDate", function(newValue) {
                            employee.metadata.tobaccoData[$scope.groupNumber][$scope.index] = employee.metadata.tobaccoData[$scope.groupNumber][$scope.index] || {};
                            employee.metadata.tobaccoData[$scope.groupNumber][$scope.index].tobaccoUsageDate = newValue;

                        });


					}
				};


				$scope.$watch('groupNumber', setTobaccoData($scope.groupNumber,'FromBroadCast'));
                $rootScope.$on('updateTobaccoStatuses', function() {
                   setTobaccoData($scope.groupNumber,'FromBroadCast');
                });

				if ($scope.editMode) {
					var groupNumber = $scope.groupNumber;
					if(window.location.href.indexOf('/find/add-coverage') !== -1 || window.location.href.indexOf('/find/review') >= 0){
                    employee.metadata.tobaccoData = employee.metadata.tobaccoData || {};
                    employee.metadata.tobaccoData[$scope.groupNumber] = employee.metadata.tobaccoData[$scope.groupNumber] || [];
                    $scope.$watch("tobaccoStatus", function(newValue) {
                        employee.metadata.tobaccoData[$scope.groupNumber][$scope.index] = employee.metadata.tobaccoData[$scope.groupNumber][$scope.index] || {};
                        employee.metadata.tobaccoData[$scope.groupNumber][$scope.index].tobaccoStatus = newValue;
                        employee.metadata.tobaccoData[$scope.groupNumber][$scope.index].pin = $scope.participant.pin || [];
                        employee.metadata.tobaccoData[$scope.groupNumber][$scope.index].fullname = $scope.participant.fullName || {};
                        employee.metadata.tobaccoData[$scope.groupNumber][$scope.index].gender = $scope.participant.gender || [];
                    });
                    $scope.$watch("tobaccoUsageDate", function(newValue) {
                        employee.metadata.tobaccoData[$scope.groupNumber][$scope.index] = employee.metadata.tobaccoData[$scope.groupNumber][$scope.index] || {};
                        employee.metadata.tobaccoData[$scope.groupNumber][$scope.index].tobaccoUsageDate = newValue;

                    });
					}

					$scope.$on('medicalPlanUpdated', function(event, additionalGroupInformation, plan, planCoverageOptin, gn) {
						if (plan.groupNumber || gn) {
							groupNumber = plan.groupNumber || gn;
						}
					});

                    $scope.$on('assignTobacco', function() {
						console.debug('heard assignTobacco');
						var addFlow = addFlowCommander.isInAddFlow();
						var emp = addFlow ? [employee.data.subscriber].concat(employee.data.dependents || []) : [employee.editInProgress.data.subscriber].concat(employee.editInProgress.data.dependents || []) ;
						assignTobacco(emp, groupNumber);
						$scope.$emit('tobaccoAssigned');
					});
				}

				function assignTobacco(empl, groupNumber) {
                    if (addFlowCommander.isInAddFlow()) {
                        for (var i = 0; i < $scope.participant.memberCoverages.length; ++i) {
                            if ($scope.participant.memberCoverages[i].groupNumber === groupNumber) {
                                $scope.participant.memberCoverages[i].tobaccoStatus = $scope.tobaccoStatus;
                                $scope.participant.memberCoverages[i].tobaccoUsageDate = $scope.tobaccoUsageDate;
                                if ($scope.tobaccoStatus && $scope.tobaccoStatus.toLowerCase() !== 't') {
                                    delete $scope.participant.memberCoverages[i].tobaccoUsageDate;
                                    console.debug('tobacco assigned');
                                    break;
                                }
                            }
                        }
                    }
                    else {
                    var emData = employee.metadata.tobaccoData;
                    empl.forEach(function (p) {
                        for (var i = 0; i < p.memberCoverages.length; ++i) {
                            for (var j = 0; j < Object.keys(emData).length; ++j) {

                                if (p.memberCoverages[i].groupNumber === Object.keys(emData)[j]) {

                                    var filEmDate = emData[p.memberCoverages[i].groupNumber].filter(function (e) {
                                        return e.pin == p.pin;
                                    });
                                    if (filEmDate.length) {
                                        p.memberCoverages[i].tobaccoStatus = filEmDate[0].tobaccoStatus;
                                        p.memberCoverages[i].tobaccoUsageDate = filEmDate[0].tobaccoUsageDate;
                                        if (filEmDate[0].tobaccoStatus && filEmDate[0].tobaccoStatus.toLowerCase() !== 't') {
                                            delete p.memberCoverages[i].tobaccoUsageDate;

                                        }
                                        console.debug('tobacco assigned');
                                        break;
                                    }else if(p.optingIn) {
                                        var filEmDateOpt = emData[p.memberCoverages[i].groupNumber].filter(function (e) {
                                            console.log("e metadata",e);
                                            console.log("p fullname",p);
                                            var comp = angular.equals(e.fullname, p.fullName);
                                            console.log("comp",comp);
                                            return (angular.equals(e.fullname, p.fullName) && e.pin.length < 1);
                                        });
                                        console.log("filEmDateOpt", filEmDateOpt);
                                        if (filEmDateOpt.length) {
                                        p.memberCoverages[i].tobaccoStatus = filEmDateOpt[0].tobaccoStatus;
                                        p.memberCoverages[i].tobaccoUsageDate = filEmDateOpt[0].tobaccoUsageDate;
                                        if (filEmDateOpt[0].tobaccoStatus && filEmDateOpt[0].tobaccoStatus.toLowerCase() !== 't') {
                                            delete p.memberCoverages[i].tobaccoUsageDate;

                                        }
                                        console.debug('tobacco assigned');
                                        }
                                        break;


                                    }
                                }
                            }


                        }
                    });
                }

				}

			}]
		};
	});
};
